/* eslint-disable */

import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type ProductOptionsQueryVariables = Types.Exact<{
    key: Types.Scalars['String'];
    version: Types.Scalars['Int'];
}>;

export type ProductOptionsQuery = {
    __typename: 'Query';
    productOptions: Array<{
        __typename: 'ProductOptions';
        key: { __typename: 'ProductAttributeKey'; key: string };
    }>;
};

export const ProductOptionsDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ProductOptions' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'key' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'version' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'productOptions' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'key' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'key' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'version' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'version' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'key' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};

/**
 * __useProductOptionsQuery__
 *
 * To run a query within a React component, call `useProductOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductOptionsQuery({
 *   variables: {
 *      key: // value for 'key'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useProductOptionsQuery(
    baseOptions: Apollo.QueryHookOptions<ProductOptionsQuery, ProductOptionsQueryVariables>
) {
    return Apollo.useQuery<ProductOptionsQuery, ProductOptionsQueryVariables>(
        ProductOptionsDocument,
        baseOptions
    );
}
export function useProductOptionsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<ProductOptionsQuery, ProductOptionsQueryVariables>
) {
    return Apollo.useLazyQuery<ProductOptionsQuery, ProductOptionsQueryVariables>(
        ProductOptionsDocument,
        baseOptions
    );
}
export type ProductOptionsQueryHookResult = ReturnType<typeof useProductOptionsQuery>;
export type ProductOptionsLazyQueryHookResult = ReturnType<typeof useProductOptionsLazyQuery>;
export type ProductOptionsQueryResult = Apollo.QueryResult<
    ProductOptionsQuery,
    ProductOptionsQueryVariables
>;
